import { Injectable }    from '@angular/core';
import { environment } from 'src/environments/environment';
import {SupplierOfferItemModel, SupplierOfferItemParamModel} from 'src/common';
import {SearchModel, SearchResultModel} from 'src/common';
import {HttpClient} from '@angular/common/http';



const localApiUrl = `${environment.apiUrl}/SupplierOfferItem`;

@Injectable()
export class SupplierOfferItemService {

  constructor(private http: HttpClient) { }

  search(search: SearchModel): Promise<SearchResultModel<SupplierOfferItemModel>> {
      return this.http.post<SearchResultModel<SupplierOfferItemModel>>(`${localApiUrl}/Search`, search).toPromise();
  }

  getAll(): Promise<SupplierOfferItemModel[]> {
	return this.http.get<SupplierOfferItemModel[]>(`${localApiUrl}/All`).toPromise();
  }

  getById(id: number): Promise<SupplierOfferItemModel> {
    return this.http.get<SupplierOfferItemModel>(`${environment.apiUrl}/SupplierOffer/SaveSupplierOfferItem/${id}`).toPromise();
  }

  delete(id: number): Promise<void> {
	return this.http.get<void>(`${environment.apiUrl}/SupplierOffer/DeleteItem?supplierOfferItemId=${id}`).toPromise();
  }

  save(model: any): Promise<void> {
    return this.http.post<void>(`${environment.apiUrl}/SupplierOffer/SaveSupplierOfferItem`, model).toPromise();
  }


  // custom-start



  supplierOfferItems(supplierOfferId): Promise<SupplierOfferItemModel[]> {
    return this.http.get<SupplierOfferItemModel[]>(`${environment.apiUrl}/SupplierOffer/SupplierOfferItems?supplierOfferId=` + supplierOfferId).toPromise();
  }

  supplierOfferItemParams(supplierOfferItemId): Promise<SupplierOfferItemParamModel[]> {
    return this.http.get<SupplierOfferItemParamModel[]>(`${environment.apiUrl}/SupplierOffer/SupplierOfferItemElements?supplierOfferItemId=` + supplierOfferItemId).toPromise();
  }

  supplierOfferItemDescriptions(supplierOfferItemId): Promise<any[]> {
    return this.http.get<SupplierOfferItemParamModel[]>(`${environment.apiUrl}/SupplierOffer/SupplierOfferItemDescriptions?supplierOfferItemId=` + supplierOfferItemId).toPromise();
  }

  // custom-end

}



